var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1228 1.323C11.627 0.892334 12.377 0.892334 12.8811 1.323L23.5478 10.5105C24.102 10.9863 24.1561 11.8189 23.6728 12.3644C23.1895 12.9099 22.3436 12.9632 21.7895 12.4875L12.002 4.05464L2.21448 12.4875C1.66031 12.9632 0.818646 12.9099 0.331146 12.3644C-0.156354 11.8189 -0.098021 10.9904 0.456146 10.5105L11.1228 1.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.3,
    d: "M2.6687 12.0938L2.67287 20.3584C2.67287 21.2648 3.4187 21.999 4.33953 21.999H7.6687C8.58953 21.999 9.33537 21.2648 9.33537 20.3584V16.7367C9.33537 16.0107 9.9312 15.4242 10.6687 15.4242H13.3354C14.0729 15.4242 14.6687 16.0107 14.6687 16.7367V20.3584C14.6687 21.2648 15.4145 21.999 16.3354 21.999H19.6895C20.6104 21.999 21.3562 21.2607 21.3562 20.3543L21.3395 12.0979L12.002 4.05469L2.6687 12.0938Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeIcon);
export default __webpack_public_path__ + "static/media/ic-home-icon.120cf9d41b6cc4eab06f2873403f5256.svg";
export { ForwardRef as ReactComponent };